// extracted by mini-css-extract-plugin
export default {"informationSection":"InformationSection_informationSection__6iyS-"};